import { render, staticRenderFns } from "./TimerAdminView.vue?vue&type=template&id=3525f0f6&scoped=true"
import script from "./TimerAdminView.vue?vue&type=script&lang=js"
export * from "./TimerAdminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3525f0f6",
  null
  
)

export default component.exports